exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content ul[data-v-4630f262]{padding:0;margin:0}.content ul li[data-v-4630f262]{list-style-type:none;text-align:left;padding:5px}.content ul li a[data-v-4630f262]{color:#fff;font-size:18px}.content ul li a[data-v-4630f262]:hover{color:#ddd}li[data-v-4630f262]{width:100%}.is-200x200[data-v-4630f262]{width:200px;max-height:200px}.is-horizontal-center[data-v-4630f262]{display:flex!important;justify-content:center}h2[data-v-4630f262]{margin-top:0!important}.is-black-ducter[data-v-4630f262]{background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4630f262","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing_Componentes/Footer.vue
// module id = 1601
// module chunks = 0